import fp from 'lodash/fp';
import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';
import { default as setTaskSuccess } from './setTaskSuccess';

const actions = createActions({
  TASK: {
    UPDATE_TASK: (task, user) => ({ task, user }),
    API: {
      UPDATE_TASK: apiResourceActionCreator('task')
    }
  }
})

export const apiAction = (authToken, formData, taskId) => commonApiActions.authenticated.postFormData(`${API_ENDPOINT}/update/${taskId}`, authToken, formData, actions.task.api.updateTask);

function* updateTask(action) {
  const authToken = yield select(authTokenSelector);

  const {
    task: {
      id,
      name,
      description,
      dueDate,
      isArchived,
      contents,
      courses,
      users,
      links,
      files,
      cpdCategorys,
      existingFiles
    },
    user
  } = action.payload

  const tasks = [{
    name,
    description,
    dueDate,
    isArchived,
    userId: user.id
  }]

  const taskTransport = {
    tasks,
    contents,
    courses,
    users,
    cpdCategorys,
    links,
    existingFiles
  }

  const formData = {
    data: taskTransport,
    file: fp.filter(file => file)(files)
  }
  yield put(apiAction(authToken, formData, id));

  const result = yield apiActionResult(actions.task.api.updateTask);

  if (result.success) {
    yield put(push({ pathname: routes.app.tasks.home }));
    yield put(setTaskSuccess.action.task.setTaskSuccess({
      success: true,
      info: 'Task successfully updated.'
    }))
  } else {
    yield put(setTaskSuccess.action.task.setTaskSuccess({
      success: false,
      info: 'Task update failed.'
    }))
  }
}

const configuration = {
  name: 'updateTask',
  action: actions,
  sagas: updateTask,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      task: action.payload.task,
      isFetching: false
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/updateTask.js